module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/logo_nanozone_jp-476e7f2ac8095c81819df386099c5307.png";